import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DialogConfig } from '../dialog-config';
import { DialogRef } from '../dialog-ref';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorComponent implements OnInit {
  model: any = {}
  constructor(
    public config: DialogConfig,
    public ref: DialogRef
  ) { }

  ngOnInit() {
    if (this.config.data) {
      this.model = this.config.data;
    }
  }

}
